import React, { createContext, use, useState } from "react";

// Create Context
export const AppContext = createContext();

// Provider Component
export default function AppProvider({ children }) {
  const api = process.env.REACT_APP_ORIGIN_API || "https://htmlgames4u.com/api";
  const originURL =
    process.env.REACT_APP_ORIGIN_HOST || "https://htmlgames4u.com";
  const [gameUrl, setGameUrl] = useState(null);
  const [thumbnailImg, setThumbnaliImg] = useState([]);
  const [categories, setCategories] = useState();
  const [gameList, setGameList] = useState([]);
  const [baseUrl, setBaseUrl] = useState(api);
  const [Backend_folder_path, setBackend_folder_path] = useState(originURL);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [token, setToken] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [pageType, setPageType] = useState("home");
  const [descreption, setDescription] = useState("");
  const [pageRefresh, setPageRefresh] = useState(0);
  const [gametitle, setGameTitle] = useState();
  const [metaTag, setMetaTag] = useState();
  const [metadata, setMetaData] = useState({
    title: "",
    keywords: "",
    descreption: "",
  });
  const [gameId, setGameId] = useState(null);
  const [gametype, setGameType] = useState(null);
  const [AppStoreLink, setAppStoreLink] = useState({
    iso_link: null,
    playstore_link: null,
  });
  const [blogId, setBlogId] = useState(null);

  const addGameUrl = (url) => {
    setGameUrl(url);
  };

  const addThumbImg = (imgpath) => {
    setThumbnaliImg(imgpath);
  };
  const setCategory = (category) => {
    //console.log("cat",category)
    setCategories(category);
  };
  const setgamelist = (gamelist) => {
    setGameList(gamelist);
  };
  const isLoggedInUser = (status) => {
    setIsLoggedIn(status);
  };
  const setUserToken = (token) => {
    setToken(token);
  };
  const setIsAdminUser = (adminstatus) => {
    setIsAdmin(adminstatus);
  };
  const setpagetype = (type) => {
    setPageType(type);
  };
  const setdescreption = (desc) => {
    setDescription(desc);
  };

  const setPageRefreshCount = (count) => {
    setPageRefresh(count);
  };
  const setgametitle = (title) => {
    setGameTitle(title);
  };
  const setmetatag = (meta) => {
    setMetaTag(meta);
  };
  const setmetadata = (data) => {
    setMetaData(data);
  };
  const setgametype = (gametype) => {
    setGameType(gametype);
  };
  const setgameid = (id) => {
    setGameId(id);
  };
  const setappstorelink = (link) => {
    setAppStoreLink(link);
  };
  const setblogid = (id) => {
    setBlogId(id);
  };
  const [gameIframe, setGameIframe] = useState(false);
  const setGameIframeStatus = (status) => {
    setGameIframe(status);
  };
  const [thumb_img, setthumb_img] = useState(true);
  const setThumbImgStatus = (status) => {
    setthumb_img(status);
  };
  return (
    <AppContext.Provider
      value={{
        gameUrl,
        addGameUrl,
        categories,
        setCategory,
        thumbnailImg,
        addThumbImg,
        gameList,
        setgamelist,
        baseUrl,
        Backend_folder_path,
        isLoggedInUser,
        isLoggedIn,
        token,
        setUserToken,
        isAdmin,
        setIsAdminUser,
        pageType,
        setpagetype,
        descreption,
        setdescreption,
        pageRefresh,
        setPageRefreshCount,
        gametitle,
        setgametitle,
        metaTag,
        setmetatag,
        metadata,
        setmetadata,
        gametype,
        setgametype,
        gameId,
        setgameid,
        AppStoreLink,
        setappstorelink,
        blogId,
        setblogid,
        setGameIframeStatus,
        gameIframe,
        thumb_img,
        setThumbImgStatus,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}
